import {  spring } from 'react-motion';
import { Connect, React } from '../../react';
import Plain from './plain';
import browserSelectors from '../../browser/selectors';

/* tslint:disable no-magic-numbers*/
export type ModalType = 'flyover' | 'flyover2' | 'top' | 'maximized' | 'center'| 'center2nd' |'smallsize1' | 'smallscreen';

const styles = {
    center: [{ translateY: -0.1, opacity: 0 }, { translateY: spring(-0.1), opacity: spring(0) }, { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
    center2nd: [{ translateY: -0.1, opacity: 0 }, { translateY: spring(-0.1), opacity: spring(0) }, { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
    smallscreen: [{ translateY: -0.1, opacity: 0 }, { translateY: spring(-0.1), opacity: spring(0) }, { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
    maximized: [{ translateY: -0.1, opacity: 0 }, { translateY: spring(-0.1), opacity: spring(0) }, { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
    smallsize1: [{ translateY: -0.1, opacity: 0 }, { translateY: spring(-0.1), opacity: spring(0) }, { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
    flyover: [{ translateY: 1.1, opacity: 1 }, { translateY: spring(1.1), opacity: 1 }, { translateY: spring(0), opacity: 1 }, { translateY: 0, opacity: 1 }],
    flyover2: [{ translateY: 1.1, opacity: 1 }, { translateY: spring(1.1), opacity: 1 }, { translateY: spring(0), opacity: 1 }, { translateY: 0, opacity: 1 }],
    top: [{ translateY: -1, opacity: 0 }, { translateY: spring(-1), opacity: spring(0) },
          { translateY: spring(0), opacity: spring(1) }, { translateY: 0, opacity: 1 }],
};

const styleHidden = 1;
const styleVisible = 2;
/* tslint:enable */

export interface IModalProps {
    visible: boolean;
    type: ModalType;
    header?: React.ReactChild;
    arialabel?: string;
    onClick?: () => any;
    onEscKeyDown?: () => any;
    backdrop?: boolean;
    minimized?: boolean;
}
export interface IModalState {
    zIndex: number;
}

let modalZIndex = 500;

@Connect(
    (state: any) => ({
        avoidSlideIn: browserSelectors.restoringSession(state),
    }),
    null,
)
export class Modal extends React.Component<IModalProps, IModalState> {
    public state = {
        zIndex: ++modalZIndex,
    };

    public render() {
        const { visible, type, header, arialabel,  onClick, onEscKeyDown, backdrop, minimized, children } = this.props;
        const { zIndex } = this.state;
    
        /* tslint:disable */
        var translateY =(visible? (styles[type][styleVisible].translateY["val"]): (styles[type][styleHidden].translateY["val"]));
        var opacity =visible? (styles[type][styleVisible].opacity["val"]): (styles[type][styleHidden].opacity["val"]);
        /* tslint:enable */
        return (
            opacity === 0 ? null :
            <Plain
                transform={{zIndex:opacity === 0? 0: zIndex, opacity: opacity, translateY: `${percentage(translateY)}%`}}
                visible={visible}
                type={type}
                header={header}
                arialabel={arialabel}
                onClick={onClick}
                onEscKeyDown={onEscKeyDown}
                backdrop={backdrop}
                minimized={minimized}>                    
                {children} 
            </Plain>
        );
    }

    public componentWillReceiveProps(nextProps: IModalProps) {
        if (this.props.visible !== nextProps.visible && nextProps.visible) {
            this.setState({ zIndex: (++modalZIndex) });
        }
    }
}

function percentage(r: number): number {
    const m = 100;
    return r * m;
}



// WEBPACK FOOTER //
// (webpack)-remove-block-loader??ref--5-0!./src/note/modal/index.tsx